import { Route, Routes, useLocation } from 'react-router-dom'
import { AccessDenied, Announcements, Calendar, CreateForm, CreateCaseForm, CreateTrainingForm, Home, KnowledgeGraph, ListView, Pii, Pmg, PointsOfContact, Qa, QuickLinks, Settings, SiteFeedback, DetailView, ReleaseNotes, Profile, TrainingListView, TrainingDetailView } from '../pages/index'
import { useContext, useEffect, useState } from 'react'
import { FetchStatus, routeTitles } from '../config/configuration'
import { useGetAllSettingsData } from '../store/settings/hooks'
import { getAllSettings } from '../store/settings/reducer'
import UnclassifiedInformation from '../utils/unclassifiedInformation'
import { UserDetailsContext } from '../utils/user-context'
import PageOverlay from '../utils/controls/pageoverLay/pageoverLay'
import { RhyBusHeader } from '@rhybus/header'
import { RhyBusSideNav } from '@rhybus/menu'
import { RhyBusWorkflow } from '@rhybus/workflow'
import { RhyBusNotifications } from '@rhybus/notifications'
import { getTabsConfig, workflowItems, workflowItemsGrant, workflowStatusColorMap } from '../config/data'
import { handleClearAllNotifications, navigateToDetailedview, onMarkAllRead, onNotificationItemRead } from '../services/notifications'
import { useGetAllNotifications } from '../services/notificationsHooks'
import { getAllNotifications } from '../services/notificationsSlice'
import { useAppDispatch } from '../store/hooks'
import logo from '../assets/images/logo.svg'
import Generate from '../shared/generate/generate'
import { RhyBusPopOver } from '@rhybus/popover'
import { useMsal } from '@azure/msal-react'
import { rhybusRListsHttp } from '../components/api/rhybus-list-http'
import FormBuilderContainer from '../formengine/formengine'
import { AUTH_PROVIDER } from '../authProvider'
import { keycloakLogout } from '../authKeycloak'

const RouteTitleHandler = () => {
  const location = useLocation()

  useEffect(() => {
    const pathname = location.pathname.startsWith('/detail-view/')
      ? '/detail-view'
      : location.pathname.startsWith('/create-requirement/')
        ? '/create-requirement'
        : location.pathname

    document.title = routeTitles[pathname] ?? 'RhyBus'

    // Move focus to main content region after every route change so
    // screen readers and keyboard users start reading from the new page top.
    const main = document.getElementById('main-content')
    if (main) {
      main.tabIndex = -1
      main.focus()
    }
  }, [location.pathname])

  return null
}
const WorkflowWrapper = () => {
  const location = useLocation()

  const isGrantWorkflow =
    location.pathname === '/createcase' ||
    location.pathname.startsWith('/createcase/') ||
    location.pathname === '/cases' ||
    location.pathname.startsWith('/detail-view')

  return (
    <RhyBusWorkflow
      items={isGrantWorkflow ? workflowItemsGrant : workflowItems}
      statusColorMap={workflowStatusColorMap}
    />
  )
}
const Routers = () => {
  const [loading, setLoading] = useState(false)
  const FetchDataStatus: any = useGetAllSettingsData()
  // const bannertext: Array<I_Banner> = useGetClassifiedText()
  const [selectedBanner, setSelectedBanner] = useState<any>()
  const { isSubmitter } = useContext(UserDetailsContext)
  const dispatch = useAppDispatch()
  const notificationItems = useGetAllNotifications()
  const dynamicNotifications = notificationItems.map(item => ({ ...item, id: item.ItemID }))
  const tabsConfig = getTabsConfig(dynamicNotifications)
  const [_collapsed, setCollapsed] = useState(false)
  const [width, _setWidth] = useState(280)
  const { accounts, instance } = useMsal()
  const [intials, setIntials] = useState('')
  const [fullName, setFullName] = useState('')
  const [email, setEmail] = useState('')
  const [profileOpen, setProfileOpen] = useState(false)

  const getUserInfo = async () => {
    const meValue = await rhybusRListsHttp().me()

    let ufirstname = meValue.firstName?.substring(0, 1) || ''
    let ulastname = meValue.lastName?.substring(0, 1) || ''

    const initialsValue = ufirstname + ulastname

    setIntials(initialsValue)
    setFullName(meValue.firstName + ' ' + meValue.lastName)
    setEmail(meValue.email)
  }

  useEffect(() => {
    getUserInfo()
  }, [])

  const handleSignOut = () => {
    if (AUTH_PROVIDER === 'keycloak') {
      keycloakLogout().catch((error) => {
        console.error('Logout error', error)
      })
      return
    }
    instance.logoutRedirect()
  }

  useEffect(() => {
    dispatch(getAllNotifications())
  }, [])

  const convertDate = (date: Date): string => {
    if (!date || isNaN(date.getTime())) return ''
    const mm = String(date.getMonth() + 1).padStart(2, '0')
    const dd = String(date.getDate()).padStart(2, '0')
    const yyyy = date.getFullYear()
    const hh = String(date.getHours()).padStart(2, '0')
    const min = String(date.getMinutes()).padStart(2, '0')
    return `${mm}/${dd}/${yyyy} ${hh}:${min}`
  }
  useEffect(() => {
    dispatch(getAllSettings())
  }, [])

  useEffect(() => {
    if (FetchDataStatus === FetchStatus.SUCCESS) {
      setLoading(false)
    }
    setLoading(false)
  }, [FetchDataStatus])

  if (loading) {
    return (
      <>
        <PageOverlay />
      </>
    )
  }
  const menuitems = [
    {
      id: 'dashboard',
      label: 'Dashboard',
      path: '/',
      iconClassName: 'icon-rb-dashboard'
    },
    {
      id: 'create',
      label: 'Create',
      path: '/createcase',
      matchPaths: ['/createcase', '/createtraining'],
      children: [
        // {
        //   id: 'case',
        //   label: 'Case',
        //   path: '/case'
        // },
        {
          id: 'case',
          label: 'Case',
          path: '/createcase'
        },
        {
          id: 'training',
          label: 'Training Track',
          path: '/createtraining',
          separator: 'separator'
        }
      ],
      iconClassName: 'icon-rb-create-form',
      separater: 'separater'
    },
    {
      id: 'cases',
      label: 'Cases',
      path: '/cases',
      matchPaths: ['/cases', '/detail-view'],
      iconClassName: 'icon-rb-requirements'
    },
    {
      id: 'trainings',
      label: 'Training Tracks',
      path: '/trainings',
      matchPaths: ['/trainings', '/training-detail-view'],
      iconClassName: 'icon-rb-graduate font-12'
    },
    {
      id: 'announcements',
      label: 'Announcements',
      path: '/announcements',
      iconClassName: 'icon-rb-announcement-mic'
    },
    {
      id: 'eventcalendar',
      label: 'Event Calendar',
      path: '/eventcalendar',
      iconClassName: 'icon-rb-calendar'
    },
    {
      id: 'knowledge-base',
      label: 'Knowledge Base',
      path: '/knowledge-base',
      iconClassName: 'icon-rb-book-open'
    },
    {
      id: 'pmg',
      label: 'Policy Memos & Guidelines',
      path: '/pmg',
      iconClassName: 'icon-rb-files-blank-fill'
    },
    {
      id: 'points-of-contact',
      label: 'Points Of Contact',
      path: '/points-of-contact',
      iconClassName: 'icon-rb-user-book'
    },
    {
      id: 'qa',
      label: 'Q&A',
      path: '/qa',
      iconClassName: 'icon-rb-question-thick'
    },
    {
      id: 'quick-links',
      label: 'Quick Links',
      path: '/quick-links',
      iconClassName: 'icon-rb-link-angle-thick',
      separator: 'separator'
    },
    {
      id: 'settings',
      label: 'Settings',
      path: '/settings',
      iconClassName: 'icon-rb-settings'
    },
    {
      id: 'site-feedback',
      label: 'Site Feedback',
      path: '/site-feedback',
      iconClassName: 'icon-rb-site-feedback'
    },
    {
      id: 'release-notes',
      label: 'Release Notes',
      path: '/release-notes',
      iconClassName: 'icon-rb-file-text-earmark'
    },
    // {
    //   id: 'form-engine',
    //   label: 'RhyBus Design Studio',
    //   path: '/form-engine/grant',
    //   matchPaths: ['/form-engine'],
    //   iconClassName: 'icon-rb-button',
    //   children: [
    //     { id: 'form-engine-grant', label: 'Grant Form', path: '/form-engine/grant' },
    //     { id: 'form-engine-training', label: 'Training Form', path: '/form-engine/createtraining' },
    //   ]
    // }
  ]
  const visibleMenuItems = isSubmitter
    ? menuitems.filter(item => item.id !== 'list-view' && item.id !== 'settings')
    : menuitems

  return (
    <>
      <a href="#wrapper" className="skip-nav">Skip to main content</a>
      {selectedBanner && (<div className='cuiHeader' id="cuiHeader">
        <UnclassifiedInformation
          classificationcolor={selectedBanner.ClassificationColor}
          Classificationmessage={selectedBanner.ClassificationMessage}
          TextColor={selectedBanner.TextColor}
        />
      </div>)}
      <div>
        <RouteTitleHandler />
        <div className='mainwrapper' id='mainwrapper'>
          <RhyBusSideNav
            items={visibleMenuItems}
            onCollapseChange={setCollapsed}
            expandedWidth={width}
            collapsedWidth={80}
            expandIcon='icon-rb-collapse-menu font-16'
            collapsedIcon='icon-rb-expand-menu font-16'
            title='DSCA Home'
            logoTemplate={
              <>
                <div className='d-flex align-items-center gap-2' style={{ cursor: 'pointer' }} onClick={() => { window.location.href = '/' }}>
                  <img src={logo} alt='DSCA' height="40" />
                  {/* <div className='logo-title'>
                       <h1 className='inter-semibold font-16'>Acquisition</h1>
                    </div> */}
                </div>
              </>
            }
            logoLink='/'
          />
          <div className='content-wrapper'>
            <RhyBusHeader
              headerLeftContent={<></>}
              headerRightContent={<>
                <div className='d-flex justify-content-end gap-2 align-items-center'>
                  <WorkflowWrapper />
                  <div className='divider vertical'></div>
                  <RhyBusNotifications
                    badge={true}
                    badgeType="text"
                    showNotificationDot={dynamicNotifications.filter((n: any) => !n.IsRead).length > 0 ? false : false}
                    popoverClassName="popup-md"
                    notificationsIcon="icon-rb-notifications font-18"
                    data={dynamicNotifications}
                    tabsConfig={tabsConfig}
                    popoverTitle='Alerts'
                    pageSize={30}
                    unreadCount={dynamicNotifications.filter((n: any) => !n.IsRead).length}
                    getItemKey={(item: { ItemID: any }) => item.ItemID}
                    getTitle={(item: any) => String(item?.Subject ?? item?.Title ?? '')}
                    getSubTitle={(item: { ItemCreated: string }) => item.ItemCreated}
                    getNotificationCode={(item: { NotificationCode: any }) => item.NotificationCode || ''}
                    isItemRead={(item: { IsRead: boolean }) => item.IsRead === true}
                    onClearAll={handleClearAllNotifications}
                    onItemClick={(item: any) => {
                      onNotificationItemRead(item)
                      navigateToDetailedview(item)
                    }}
                    formatDate={(item: { ItemCreated: string }) => {
                      const date = new Date(item.ItemCreated)
                      return convertDate(date)
                    }}
                    onMarkAllRead={onMarkAllRead}
                  />

                  <div className='divider vertical mx-1'></div>
                  <RhyBusPopOver
                    popoverclassName="userlogin-popover"
                    visible={profileOpen}
                    onVisibleChange={setProfileOpen}
                    trigger="click"
                    placement="auto"
                    popoverBodyclassName='border-radius'
                    content={
                      <div className="whitebg min-w-300 border-radius">
                        <div className='d-flex justify-content-between align-items-center w-100'>
                          <div className='color-primary inter-semibold font-12 border-radius-0' tabIndex={0} aria-label='DSCA'>DSCA</div>
                          <button
                            onClick={handleSignOut}
                            className='btn no-border btn-sm links border-radius-0'
                            title='Sign Out'
                          >
                            Sign out
                          </button>
                        </div>

                        <div className='d-flex align-items-center w-100 my-2'>
                          <div className='profilepic d-flex align-items-center me-3'>
                            <div className='userbutton d-flex justify-content-center align-items-center'>
                              {intials}
                            </div>
                          </div>
                          <div className='user_accountDetails'>
                            <div className='bold font-14 inter-medium border-radius-0' tabIndex={0} aria-live='polite'>
                              {accounts[0]?.name}
                            </div>
                            <p className='py-1 border-radius-0' tabIndex={0} aria-label={email}>{email}</p>
                            <a href='/#' className='links border-radius-0'>View Account</a>
                          </div>
                        </div>

                      </div>
                    }
                  >
                    <div role='button' aria-label='User Profile' className='profilepic d-flex align-items-center cursor' title={intials}>
                      <div className='userbutton d-flex justify-content-center align-items-center inter-semibold'>
                        {intials}
                      </div>
                    </div>
                  </RhyBusPopOver>
                </div>
              </>}
            />
            <div className='wrapper' id='wrapper' tabIndex={-1}>
              <Routes>
                <Route path='/' element={<Home />} />
                <Route path='/createcase' element={<CreateForm />} />
                <Route path='/createcase/:itemGuid' element={<CreateForm />} />
                <Route path='/createtraining' element={<CreateTrainingForm />} />
                <Route path='/createtraining/:itemGuid' element={<CreateTrainingForm />} />
                <Route path='/cases' element={<ListView />} />
                <Route path='/trainings' element={<TrainingListView />} />
                <Route path='/detail-view' element={<DetailView />} />
                <Route path='/detail-view/:itemGuid' element={<DetailView />} />
                <Route path='/training-detail-view' element={<TrainingDetailView />} />
                <Route path='/training-detail-view/:itemGuid' element={<TrainingDetailView />} />
                <Route path='/accessdenied' element={<AccessDenied />} />
                <Route path='/announcements' element={<Announcements />} />
                <Route path='/eventcalendar' element={<Calendar />} />
                <Route path='/knowledge-base' element={<KnowledgeGraph />} />
                <Route path='/pii' element={<Pii />} />
                <Route path='/pmg' element={<Pmg />} />
                <Route path='/points-of-contact' element={<PointsOfContact />} />
                <Route path='/qa' element={<Qa />} />
                <Route path='/quick-links' element={<QuickLinks />} />
                <Route path='/settings' element={<Settings />} />
                <Route path='/site-feedback' element={<SiteFeedback />} />
                <Route path='/release-notes' element={<ReleaseNotes />} />
                <Route path='/profile' element={<Profile />} />
                <Route path='/form-engine' element={<FormBuilderContainer />} />
                <Route path='/form-engine/:formType' element={<FormBuilderContainer />} />
                <Route path='/appconfig' element={<Generate />} />

              </Routes>
            </div>
          </div>
        </div>

      </div>
    </>
  )
}

export default Routers
